"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "TeachingPopover", {
    enumerable: true,
    get: function() {
        return TeachingPopover;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useTeachingPopover = require("./useTeachingPopover");
const _renderTeachingPopover = require("./renderTeachingPopover");
const TeachingPopover = (props)=>{
    const state = (0, _useTeachingPopover.useTeachingPopover_unstable)(props);
    return (0, _renderTeachingPopover.renderTeachingPopover_unstable)(state);
};
TeachingPopover.displayName = 'TeachingPopover';
